<template>
	<div>
		<v-form ref="form" class="" lazy-validation @submit.prevent="submit">
			<v-card class="mx-auto" max-width="400">
				<v-card-title class="blue--text" style="font-size:18px;justify-content: center;">پرداخت آنلاین</v-card-title>
				<v-img class="align-end text-white" height="150" contain :src="require('@/assets/online-payment.webp')">
				</v-img>

				<v-card-subtitle class="pt-4 text-center" v-show="showLoanDetail">
					کد وام: {{ code }} - قسط شماره {{ number }}
				</v-card-subtitle>

				<v-card-text>
					<v-row>
						<v-col cols="12 pb-0">
							<v-text-money class="align-center center-input" :disabled="true" v-model="installment" label="مبلغ قسط (تومان)" :error-messages="errorMessages" />
						</v-col>
						<v-col cols="12 py-0" v-if="delay2 != 0">
							<v-text-money class="align-center center-input" :disabled="true" v-model="delay2" :label="`${this.data.payment.delayDay < 0 ? 'زودکرد' : 'جریمه تاخیر'} (تومان)`" :error-messages="errorMessages" />
						</v-col>
						<v-col cols="12 py-0" v-if="discount > 0">
							<v-text-money class="align-center center-input" :disabled="true" v-model="discount" label="تخفیف (تومان)" :error-messages="errorMessages" />
						</v-col>
						<v-col cols="12 py-0">
							<v-text-money class="align-center center-input" :disabled="true" v-model="amount" label="قابل پرداخت (تومان)" :error-messages="errorMessages" :rules="[() => amount > 0 || 'مبلغ را به صورت صحیح وارد کنید']" required />
						</v-col>
					</v-row>

				</v-card-text>

				<v-card-actions class="d-flex align-center justify-center mb-12">
					<v-btn v-if="!$vuetify.breakpoint.smAndDown" color="orange" type="submit" :loading="submitLoading" :disabled="this.amount === 0">
						پرداخت
					</v-btn>
				</v-card-actions>
			</v-card>
			<v-bottom-navigation elevation="0" v-model="nav" active fixed color="primary" v-if="$vuetify.breakpoint.smAndDown" style="background-color: #f5f9ff;border-top: 1px solid #ddd;box-shadow: none;">
				<v-btn type="submit" :loading="submitLoading" :disabled="this.amount === 0">
					هدایت به درگاه جهت پرداخت
					<v-icon>mdi-cart-outline</v-icon>
				</v-btn>
			</v-bottom-navigation>
		</v-form>

	</div>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'

export default {
	name: 'OnlinePayment',
	props: {
		data: { type: Object },
		showLoanDetail: { type: Boolean, default: true }
	},
	data() {
		return {
			errorMessages: '',
			installment: 0,
			discount: 0,
			delay: 0,
			delay2: 0,
			amount: 0,
			localData: {},
			submitLoading: false,
			gatewayUrl: '',
			sepToken: '',
			nav: ''
		}
	},
	computed: {
		code() {
			return this.data?.userLoanModel?.code
		},
		number() {
			return this.data?.payment?.installmentNumber
		}
	},
	mounted() {
		this.installment = this.data.payment.installmentAmount
		this.discount = this.data.payment.discount
		this.delay = this.data.payment.delayPrice ? this.data.payment.delayPrice * (this.data.payment.delayDay < 0 ? -1 : 1) : '0'
		this.delay2 = Math.abs(this.delay)
		this.amount = Math.max(this.installment + Number(this.delay) - this.data.payment.sumAmount - this.discount, 0)
		if (this.number === this.data?.userLoanModel?.month)
			this.amount = Math.min(this.amount, this.data.userLoanModel.remain)
		this.payable = this.amount
	},
	methods: {
		submit() {
			if (!this.$refs.form.validate()) { return }
			if (this.amount != this.payable) {
				toast.error('مبلغ وارد شده با مبلغ قابل پرداخت مغایرت دارد.')
				return
			}

			let data = {
				amount: this.amount,
				userLoanPayment: this.data.payment,
				customerCode: this.data.customerCode || 0
			}
			if (this.data?.userLoanModel?.memberModel)
				data.user = this.data.userLoanModel.memberModel
			this.submitLoading = true
			let url = 'member/purchase/create'
			if (this.data.customerCode)//when this component created by preOnlinePayment, costomer code filled and it probably user not signed in so we request to public memberPurchase
				url = 'memberpurchase/create'
			api.post(url, data, { authHeader: !this.data.customerCode, contentType: 'application/json' })
				.then(response => {
					if (response.gateway === 'sep') {
						let form = document.getElementById('sepForm')
						let sepToken = document.getElementById('sepToken')
						sepToken.value = response.token
						form.submit()
					}
					else if (response.gateway === 'sepehr') {
						let form = document.getElementById('sepehrForm')
						let sepehrToken = document.getElementById('sepehrToken')
						sepehrToken.value = response.token
						let sepehrTerminal = document.getElementById('sepehrTerminalId')
						sepehrTerminal.value = response.terminalId
						form.submit()
					}
					else {
						window.location.replace(response.gatewayUrl)
					}
				})
				.catch(err => {
					this.submitLoading = false
					toast.error(err.message)
				})
		}
	},
}
</script>
<style></style>
